import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import React, { useContext, useState, useEffect } from 'react';
import { Col, Container, Row, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/Button';
import DefaultCard from '../../components/DefaultCard';
import CustomSelect from '../../components/Select/Select';
import DatePickerInput from '../../components/DatePicker';
import Blockquote from '../../components/Blockquote';
import GenericCard from '../../components/GenericCards/GenericCards';
import GenericList, {
  GenericListItem,
} from '../../components/GenericList';
import Link from '../../components/Link';
import Label from '../../components/Label';
import {
  addOrRemoveDaysToGivenDate,
  formatDate,
  DateFormats,
  formatPrice,
  openExternalLink,
} from '../../utils/utils';
import {
    COBRA_BENEFITS_ENROLLMENT_ROUTE,
    HEALTH_SUMMARY,
} from '../../routes/types';

//Payment History Asset
import AccordionByDate from '../widgets/BenefitElectionHistory/ElectionByDate';


export type BenefitElectionHistoryProps = React.PropsWithChildren<{
    selectValue: string | number;
    onChangeElectionHistory?: (selectValue: any) => void;
}>;
  
const BenefitElectionHistory = ({
    selectValue,
  }: BenefitElectionHistoryProps) => {
  const [selectedOption, setSelectedOption] = useState<string>('');
  const [selectedEvent, setSelectedEvent] = useState<string>('');
  const [selectedDate, setSelectedDate] = useState<string>('');
  const [selectedBenefit, setSelectedBenefit] = useState<string>('');
  const [showBenefitOnDate, setShowBenefitOnDate] = useState<boolean>(false);
  const navigate = useNavigate();
    
    // Function to hide the div with class 'sub-select-col' on page load
  const hideSubSelectColOnLoad = () => {
    const subSelectCol = document.querySelector('.sub-select-col');
    if (subSelectCol) {
      (subSelectCol as HTMLElement).style.display = 'none';
    }
  };

    const genericListContent = [
        {
            linkTitle: 'Contacts',
            linkRIcon: light('chevron-right'),
            url: 'resources/contacts',
        },
        
        {
            linkTitle: 'Info/Forms',
            linkRIcon: light('chevron-right'),
            url: 'resources/documents',
        },
    ];

    const eventElectionByOptions = [
        {
          value: `Event`,
          label: `Event`,
        },
        {
          value: `Date`,
          label: `Date`,
        },
        {
          value: `Benefit`,
          label: `Benefit`,
        },
    ];

    const eventOptions = [
        {
          value: `1/1/2024`,
          label: `Open Enrollment 1/1/2024`,
        },
        {
          value: `1/1/2023`,
          label: `Open Enrollment 1/1/2023`,
        },
        {
          value: `1/1/2022`,
          label: `Open Enrollment 1/1/2022`,
        },
        {
          value: `4/2/2021`,
          label: `Return From Leave 4/2/2021`,
        },
        {
          value: `1/1/2021`,
          label: `Open Enrollment 1/1/2021`,
        },
    ];

    const benefitOptions = [
      {
        value: `EHB01`,
        label: `Group Accident Inssurance`,
      },
      {
        value: `EHB02`,
        label: `Basic Life Insurance`,
      },
      {
        value: `EHB03`,
        label: `Child Life Insurance`,
      },
      {
        value: `EHB04`,
        label: `Dependant Care Flexible Spending Account`,
      },
      {
        value: `EHB05`,
        label: `Dental`,
      },
      {
        value: `EHB06`,
        label: `Healthcare Flexible Spending Account`,
      },
      {
        value: `EHB07`,
        label: `Health Savings Account`,
      },
      {
        value: `EHB08`,
        label: `Limited Purpose Flexible Spending Account`,
      },
      {
        value: `EHB09`,
        label: `Long-Term Disability Coverage`,
      },
      {
        value: `EHB10`,
        label: `Medical`,
      },
      {
        value: `HB11`,
        label: `Private Pilots Accident Insurance`,
      },
      {
        value: `EHB12`,
        label: `Spouse/Domestic Partner Life Insurance`,
      },
      {
        value: `EHB13`,
        label: `Short-Term Disabilitiy Coverage`,
      },
      {
        value: `EHB14`,
        label: `Optional Life Insurance`,
      },
      {
        value: `EHB15`,
        label: `COVID Surcharge`,
      },
      {
        value: `EHB16`,
        label: `Vision`,
      },
  ];

    const onChangeElectionHistory = (e: any) => {
      
      const subSelectCol = document.querySelector('.sub-select-col') as HTMLElement;
      const labelElement = document.querySelector('.sub-select-col .form-label');
      setSelectedOption(e);
      if (e === 'Event'){
        if (labelElement) {
          // Change the label text from 'Event' to 'Past Event'
          labelElement.textContent = 'Past Event:';
        }
        subSelectCol.style.display = 'block';
      } else if (e === 'Date'){
        if (labelElement) {
          // Change the label text from 'Event' to 'Past Event'
          labelElement.textContent = 'Benefit Date:';
        }
        subSelectCol.style.display = 'block';
      } else if (e === 'Benefit'){
        if (labelElement) {
          // Change the label text from 'Event' to 'Past Event'
          labelElement.textContent = 'Benefit Type:';
        }
        subSelectCol.style.display = 'block';
      }
    };
    
    const handleSelectPastEvent = (e: any) => {
      setSelectedEvent(e);
    };

    const handleSelectBenefit = (e: any) => {
      setSelectedBenefit(e);
    };

    

    const handleDateChange = (e: any) => {
      const eDate = new Date(e);
      const noBenefitDate = document.querySelector('.no-benefit-date') as HTMLElement;
      const withBenefitDates = document.querySelectorAll('.with-benefit-date') as NodeListOf<HTMLElement>;

      if (isNaN(eDate.getTime())) {
        console.error("Invalid date format:", e);
        return;
      } else {
        setShowBenefitOnDate(true)
        setSelectedDate(e);

        const today = new Date();
        today.setHours(0, 0, 0, 0); // Set to midnight to compare dates only
        eDate.setHours(0, 0, 0, 0);

        if (eDate > today) {
          //The selected date is in the future
          //console.log("The selected date is in the future:", eDate);
          //downloadBtn.style.display = 'none';
          withBenefitDates.forEach(withBenefitDate => {
            withBenefitDate.style.display = 'none';
          });
          if (noBenefitDate) {
            noBenefitDate.style.display = 'block';
          }
        } else if (eDate <= today) {
          //The selected date is today or in the past
          //downloadBtn.style.display = 'block';
          withBenefitDates.forEach(withBenefitDate => {
            withBenefitDate.style.display = 'block';
          });
          if (noBenefitDate) {
            noBenefitDate.style.display = 'none';
          }
        } else {
          //downloadBtn.style.display = 'none';
          //noBenefitDate.style.display = 'none';
        }
      }
    };

    

    // Call the function to hide the div on component mount
    useEffect(() => {
      hideSubSelectColOnLoad();
    }, []);

    
  
    return (
        
        <Container className="cnd-custom-container-large mb-12 px-lg-9 px-xl-0">
          <Row className={'mt-7 mt-lg-13'}>
            <Col
              sm={12}
              lg={8}
              className={
                'd-flex justify-content-between align-items-center pt-lg-8'
              }
            >
              <h4 className={'h4 fw-light mb-0'}>{'Benefit Election History'}</h4>
            </Col>
          </Row>
          <Row className={'mt-10'}>
            <Col sm={12} lg={8}>
              <GenericCard
                className={'p-10'}
                variant="white"
                style={{ zIndex: '1000' }}
              >
                <Row>
                  <Col sm={12} align="end" className={'mb-10'}>
                    <Button
                      onClick={() => navigate(HEALTH_SUMMARY)}
                      className={'previous-btn'}
                      variant={'primary-outline'}
                      leftIcon={light('arrow-left')}
                    >
                      Back to Current Benefits
                    </Button>
                  </Col>
                </Row>
                <Row className={'mb-10'}>
                  <Col sm={12} lg={6}>
                    <CustomSelect
                      name={'mainSelect'}
                      minWidth={'226'}
                      label={'Election History By:'}
                      onChange={onChangeElectionHistory}
                      options={eventElectionByOptions}
                      value={selectValue}
                    />
                  </Col>
                  <Col className="sub-select-col" sm={12} lg={6}>
                  {selectedOption === 'Event' && (
                    <CustomSelect
                      name={'subSelect'}
                      minWidth={'226'}
                      label={'Past Event:'}
                      onChange={handleSelectPastEvent}
                      options={eventOptions}
                    />
                  )}
                  {selectedOption === 'Date' && (
                    <DatePickerInput
                    placeholder={'Select a date'}
                    label={'Benefit Date:'}
                    onChange={(date) => handleDateChange(date)}
                    />
                  )}
                  {selectedOption === 'Benefit' && (
                    <CustomSelect
                    name={'subSelect'}
                    minWidth={'226'}
                    label={'Benefit Event:'}
                    onChange={handleSelectBenefit}
                    options={benefitOptions}
                    />
                  )}
                  </Col>
                </Row>
                {selectedOption === '' && (
                <Row>
                  <Col sm={12}>
                    <Blockquote className={'mb-5 '}>
                      <span className={'text-dark-gray fw-bold'}>
                        Explore your benefit coverage history by:
                      </span>
                      <ul className="text-dark-gray">
                        <li>
                          <strong>Event</strong> - view a prior life event
                        </li>
                        <li>
                          <strong>Date</strong> - view coverage at a certain point
                          in time
                        </li>
                        <li>
                          <strong>Benefit</strong> - view history of any benefit
                        </li>
                      </ul>
                    </Blockquote>
                  </Col>
                </Row>
                )}
                {selectedOption === 'Event' && selectedEvent != '' && (
                <>
                  <Row>
                    <Col sm={12} className="d-flex flex-column align-items-stretch  align-items-sm-end mt-11 mt-lg-0">
                      <Button
                        variant="primary-outline"
                        className={'mx-lg-10 order-1 order-lg-3'}
                        size="sm"
                      >
                        Download/Print
                      </Button>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={12} className={'mt-5 mb-10'}>
                      <Blockquote className={'mb-5'}>
                        <span className={'text-dark-gray'}>
                          The coverages shown below display benefits and family member coverages as of the selected event
                        </span>
                      </Blockquote>
                    </Col>
                  </Row>
                  <Row className={'w-100 fw-light m-0 justify-content-between'}>
                    <Col
                      className={
                        'px-0 py-7 py-lg-0 col-12 col-lg-6 d-flex flex-column justify-content-center border-bottom-mobile order-2 order-lg-1'
                      }
                    >
                      <Row
                        className={
                          'flex-row flex-lg-column align-items-center align-items-lg-start'
                        }
                      >
                        <Col className={'col-12'}>
                          <h5 className="p-0">Open Enrollment</h5>
                        </Col>

                        <Col
                          className={
                            'col-12 mt-0 mt-lg-4 lh-xxs text-end text-lg-start'
                          }
                        >
                          <span className={'text-light-grey'}>Confirmation number:</span> 15327230233
                        </Col>
                      </Row>
                    </Col>

                    <Col
                      className={
                        'col-12 col-lg-6 pb-7 pb-lg-0 border-bottom-mobile order-1 order-lg-2'
                      }
                    >
                      <Row className={'flex-row flex-lg-column'}>
                        <Col
                          className={
                            'px-0 text-dark-gray text-sm-12-lg-14 d-flex justify-content-lg-end'
                          }
                        >
                          <Label
                            className={
                              'text-dark-gray text-sm-12-lg-14 text-lg-end p-0'
                            }
                            rightIcon={light('circle-exclamation')}
                            tooltip={
                              <div className="px-1">
                                <div className="d-flex justify-content-between py-3 border-bottom-dark-gray">
                                  <span className="me-5">Before-Tax</span>
                                  <span>{`${formatPrice(Number(650.91), 'en-US', {
                                    currency: 'USD',
                                    style: 'currency',
                                    minimumFractionDigits: 2,
                                  })}`}</span>
                                </div>
                                <div className="d-flex justify-content-between py-3">
                                  <span>After-Tax</span>
                                  <span>{`${formatPrice(Number(17.5), 'en-US', {
                                    currency: 'USD',
                                    style: 'currency',
                                    minimumFractionDigits: 2,
                                  })}`}</span>
                                </div>
                              </div>
                            }
                          >
                            {'Total Cost'}
                          </Label>
                        </Col>

                        <Col className={'text-end'}>
                          <div className={'text-primary fs-5 my-4 text-lg-end'}>
                            {formatPrice(668.41)}
                          </div>
                          <div
                            className={
                              'text-light-grey text-fs-6 fw-light text-lg-end'
                            }
                          >
                            {`per-pay-period`}
                          </div>
                        </Col>
                      </Row>
                      
                    </Col>

                    <Col className={'col-12 order-3 px-0 pt-7 pt-lg-0 d-flex'}>
                        <span className={'text-light-grey'}>Submitted: </span> {formatDate(new Date(selectedEvent), DateFormats.MONTH_DAY_YEAR)}
                    </Col>

                  </Row>
                  <Row className={'with-benefit-date mt-10'} style={{display: 'show'}}>
                    <AccordionByDate></AccordionByDate>
                  </Row>
                </>
                )}
                {selectedOption === 'Date' && selectedDate != '' && showBenefitOnDate && (
                  <>
                   <Row className={'with-benefit-date'} style={{display: 'none'}}>
                    <Col sm={12} className="d-flex flex-column align-items-stretch  align-items-sm-end mt-11 mt-lg-0">
                      <Button
                        variant="primary-outline"
                        className={'mx-lg-10 order-1 order-lg-3'}
                        size="sm"
                      >
                        Download/Print
                      </Button>
                    </Col>
                  </Row>
                  <Row className={'no-benefit-date'} style={{display: 'none'}}>
                    <Col sm={12} className={'mt-5 mb-10'}>
                      <Blockquote className={'mb-5'}>
                        <span className={'text-dark-gray'}>
                          Our records show no benefit elections for the date you selected.
                        </span>
                      </Blockquote>
                    </Col>
                  </Row>
                  <Row className={'with-benefit-date w-100 fw-light mt-10 justify-content-between'} style={{display: 'none'}}>
                    <Col
                      className={
                        'col-12 pb-7 pb-lg-0 border-bottom-mobile order-1 order-lg-2'
                      }
                    >
                      <Row className={'flex-row flex-lg-column'}>
                        <Col
                          className={
                            'px-0 text-dark-gray text-sm-12-lg-14 d-flex justify-content-lg-end'
                          }
                        >
                          <Label
                            className={
                              'text-dark-gray text-sm-12-lg-14 text-lg-end p-0 me-lg-5'
                            }
                          >
                            {'Your Cost'}
                          </Label>
                        </Col>

                        <Col className={'text-end'}>
                          <div className={'text-primary fs-5 my-4 text-lg-end'}>
                            {formatPrice(117.16)}
                          </div>
                          <div
                            className={
                              'text-light-grey text-fs-6 fw-light text-lg-end'
                            }
                          >
                            {`per-pay-period`}
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row className={'with-benefit-date mt-10'} style={{display: 'none'}}>
                    <AccordionByDate></AccordionByDate>
                  </Row>
                  </>
                )}
                {selectedOption === 'Benefit' && selectedBenefit != '' && selectedBenefit === 'EHB02' && (
                <>
                  <Row className={'border-bottom-dark-gray py-8'}>
                    <Col className={'col-g-4 text-fs-6 m-0'}>
                      Date
                    </Col>
                    <Col className={'col-g-4 text-fs-6 m-0'}>
                      <span className={'text-fs-6'}>Plan</span>
                    </Col>
                    <Col className={'col-g-4 text-fs-6 m-0'}>
                      <span className={'text-fs-6'}>Who's Covered</span>
                    </Col>
                  </Row>
                  <Row
                    className={
                      'striped-rows-fixed-children px-8 py-11 px-lg-0 py-lg-8 d-flex flex-lg-row flex-wrap align-items-center border-bottom border-info'
                    }
                    key={1}
                  >
                    <Col className={'col-g-4 text-fs-6 m-0'}>
                      1/1/2014 - 12/31/2023
                    </Col>
                    <Col className={'col-g-4 text-fs-6 m-0'}>
                      Coverage $50,000
                    </Col>
                    <Col className={'col-g-4 text-fs-6 m-0'}>
                      <div><span className={'no-img position-relative'} style={{ width: '32px', height: '32px' }}>You</span></div>
                    </Col>
                  </Row>
                  <Row
                    className={
                      'striped-rows-fixed-children px-8 py-11 px-lg-0 py-lg-8 d-flex flex-lg-row flex-wrap align-items-center border-bottom border-info'
                    }
                    key={1}
                  >
                    <Col className={'col-g-4 text-fs-6 m-0'}>
                      10/16/2010 - 12/31/2013
                    </Col>
                    <Col className={'col-g-4 text-fs-6 m-0'}>
                      1 x annual pay $50,000
                    </Col>
                    <Col className={'col-g-4 text-fs-6 m-0'}>
                    </Col>
                  </Row>
                  <Row
                    className={
                      'striped-rows-fixed-children px-8 py-11 px-lg-0 py-lg-8 d-flex flex-lg-row flex-wrap align-items-center border-bottom border-info'
                    }
                    key={1}
                  >
                    <Col className={'col-g-4 text-fs-6 m-0'}>
                      5/16/2008 - 10/15/2010
                    </Col>
                    <Col className={'col-g-4 text-fs-6 m-0'}>
                      Coverage $50,000
                    </Col>
                    <Col className={'col-g-4 text-fs-6 m-0'}>
                    </Col>
                  </Row>
                </>
                )}
                {selectedOption === 'Benefit' && selectedBenefit != '' && selectedBenefit === 'EHB05' && (
                <>
                <Row className={'border-bottom-dark-gray py-8'}>
                  <Col className={'col-g-4 text-fs-6 m-0'}>
                    Date
                  </Col>
                  <Col className={'col-g-4 text-fs-6 m-0'}>
                    <span className={'text-fs-6'}>Plan</span>
                  </Col>
                  <Col className={'col-g-4 text-fs-6 m-0'}>
                    <span className={'text-fs-6'}>Who's Covered</span>
                  </Col>
                </Row>
                <Row
                  className={
                    'striped-rows-fixed-children px-8 py-11 px-lg-0 py-lg-8 d-flex flex-lg-row flex-wrap align-items-center border-bottom border-info'
                  }
                  key={1}
                >
                  <Col className={'col-g-4 text-fs-6 m-0'}>
                    1/1/2009 - 12/31/2023
                  </Col>
                  <Col className={'col-g-4 text-fs-6 m-0'}>
                    Comprehensive Dental Option
                  </Col>
                  <Col className={'col-g-4 text-fs-6 m-0'}><div><span className={'no-img position-relative'} style={{ width: '32px', height: '32px' }}>You</span></div></Col>
                </Row>
                <Row
                  className={
                    'striped-rows-fixed-children px-8 py-11 px-lg-0 py-lg-8 d-flex flex-lg-row flex-wrap align-items-center border-bottom border-info'
                  }
                  key={1}
                >
                  <Col className={'col-g-4 text-fs-6 m-0'}>
                    10/16/2010 - 12/31/2013
                  </Col>
                  <Col className={'col-g-4 text-fs-6 m-0'}>
                    No Coverage
                  </Col>
                  <Col className={'col-g-4 text-fs-6 m-0'}></Col>
                </Row>
                <Row
                  className={
                    'striped-rows-fixed-children px-8 py-11 px-lg-0 py-lg-8 d-flex flex-lg-row flex-wrap align-items-center border-bottom border-info'
                  }
                  key={1}
                >
                  <Col className={'col-g-4 text-fs-6 m-0'}>
                     
                  </Col>
                  <Col className={'col-g-4 text-fs-6 m-0'}>
                  
                  </Col>
                  <Col className={'col-g-4 text-fs-6 m-0'}></Col>
                </Row>
                </>
                )}
              </GenericCard>
            </Col>
            <Col sm={12} lg={4} className={'mt-11 mt-lg-0'}>
              <DefaultCard
                isCurrentEvent
                className=""
                variant="blue"
                leftHeading={<div className="text-sm-20-lg-32">Current Events</div>}
                leftSubheading={
                  <Container className="p-0">
                    <Row className={'align-items-end'}>
                      <Col className={'col-8'}>
                        <Row>
                          <Col className="text-sm-12-lg-14 text-nowrap col-12 fw-normal">
                            Enroll in COBRA Coverage
                          </Col>
                          <Col className="text-caption text-nowrap col-7 fw-light">
                            {`Deadline: ${formatDate(
                              addOrRemoveDaysToGivenDate(new Date(), 25)
                            )}`}
                          </Col>
                          <Col className="pb-3 text-caption text-nowrap col-7 fw-light">
                            Status: Pending Payment
                          </Col>
                        </Row>
                      </Col>
                      <Col className={'col-4 mb-3 text-end'}>
                        <Button
                          onClick={() => navigate(COBRA_BENEFITS_ENROLLMENT_ROUTE)}
                          variant={'primary-shadow'}
                          size="sm"
                        >
                          Change
                        </Button>
                      </Col>
                    </Row>
                  </Container>
                }
              />
    
              <h6 className={'fs-10 mt-10'}>Helpful Information</h6>
              <GenericCard className={'mt-7'} variant={'white'}>
                <GenericList>
                  {genericListContent.map((genericListItem, idx) => {
                    return (
                      <GenericListItem key={idx}>
                        <Link
                          rightIcon={genericListItem.linkRIcon}
                          eventKey="test"
                          isAlignAtEnd
                          isBlue
                          isBlueIcon
                          className={'py-0'}
                          href={'#/' + genericListItem.url}
                        >
                          {genericListItem.linkTitle}
                        </Link>
                      </GenericListItem>
                    );
                  })}
                </GenericList>
              </GenericCard>
            </Col>
          </Row>
          
        </Container>
      );
  };
  
  export default BenefitElectionHistory;
  